export default __webpack_public_path__ + "static/media/kyber.7212d0fb.svg";